// import React, { useState } from 'react';
// import styled from 'styled-components';
// import { Fade } from 'react-awesome-reveal';
// import KidsCodePageHero from './KidsCodePageHero';

// const PageContainer = styled.div`
//   background-color: #fcf8f5;
//   color: #1a1a1a;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//   overflow-x: hidden;
//   padding: 0;
//   margin: 0;
//   width: 100%;
//   margin-top: 50px;
// `;

// const Section = styled.section`
//   padding: 10px;
//   margin: 10px auto;
//   max-width: 1200px;
// `;

// const HeroSection = styled(Section)`
//   text-align: center;
//   padding: 20px 10px;
//   background: linear-gradient(135deg, #fef3c7, #fff7ed);
//   border-radius: 12px;
//   border: 1px solid #fde68a;
//   box-shadow: 0 4px 15px rgba(245, 158, 11, 0.05);
// `;

// const Badge = styled.span`
//   background: #fef3c7;
//   color: #d97706;
//   font-size: 11px;
//   font-weight: 800;
//   padding: 4px 12px;
//   border-radius: 20px;
//   letter-spacing: 0.5px;
//   text-transform: uppercase;
//   border: 1px solid #fde68a;
// `;

// const Title = styled.h1`
//   font-size: 32px;
//   color: #111827;
//   margin: 10px 0;
//   line-height: 1.2;
//   font-weight: 900;
//   word-break: break-word;
// `;

// const Subtitle = styled.p`
//   font-size: 16px;
//   color: #4b5563;
//   margin: 0 auto;
//   max-width: 700px;
//   line-height: 1.4;
//   word-break: break-word;
// `;

// const SectionHeader = styled.h2`
//   font-size: 26px;
//   background: linear-gradient(135deg, #f59e0b, #d97706, #b45309);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   text-align: center;
//   margin: 16px 0 10px 0;
//   font-weight: 800;
//   letter-spacing: -0.5px;
// `;

// const MotivationGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 10px;
//   margin: 10px 0;
// `;

// const MotivationCard = styled.div`
//   background: #ffffff;
//   border: 1px solid #e5e7eb;
//   padding: 15px;
//   border-radius: 10px;
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
//   border-left: 4px solid #f59e0b;
// `;

// const CardTitle = styled.h3`
//   font-size: 18px;
//   color: #1f2937;
//   margin: 0;
//   font-weight: 700;
// `;

// const CardText = styled.p`
//   font-size: 14px;
//   color: #4b5563;
//   margin: 0;
//   line-height: 1.4;
//   word-break: break-word;
// `;

// const FormWrapper = styled.div`
//   background: #ffffff;
//   border: 1px solid #e5e7eb;
//   border-radius: 12px;
//   padding: 20px;
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
//   margin: 15px 0;
// `;

// const FormNotice = styled.div`
//   background: #fef3c7;
//   border-left: 4px solid #f59e0b;
//   padding: 12px;
//   font-size: 14px;
//   color: #92400e;
//   border-radius: 0 6px 6px 0;
//   margin-bottom: 15px;
//   line-height: 1.4;
// `;

// const FormGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, 1fr);
//   gap: 12px;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const FormGroup = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;
//   grid-column: ${({ fullWidth }) => (fullWidth ? 'span 2' : 'span 1')};

//   @media (max-width: 768px) {
//     grid-column: span 1;
//   }
// `;

// const Label = styled.label`
//   font-size: 14px;
//   font-weight: 600;
//   color: #374151;
// `;

// const Input = styled.input`
//   padding: 10px 12px;
//   border: 1px solid #d1d5db;
//   border-radius: 6px;
//   font-size: 14px;
//   color: #1f2937;
//   background: #f9fafb;
//   outline: none;
//   transition: border-color 0.2s;

//   &:focus {
//     border-color: #f59e0b;
//     background: #ffffff;
//   }
// `;

// const Select = styled.select`
//   padding: 10px 12px;
//   border: 1px solid #d1d5db;
//   border-radius: 6px;
//   font-size: 14px;
//   color: #1f2937;
//   background: #f9fafb;
//   outline: none;
//   transition: border-color 0.2s;

//   &:focus {
//     border-color: #f59e0b;
//     background: #ffffff;
//   }
// `;

// const CheckboxContainer = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 10px;
//   margin-top: 10px;
//   grid-column: span 2;
//   background: #fffbeb;
//   border: 1px solid #fde68a;
//   padding: 12px;
//   border-radius: 6px;

//   @media (max-width: 768px) {
//     grid-column: span 1;
//   }
// `;

// const Checkbox = styled.input`
//   margin-top: 3px;
//   accent-color: #f59e0b;
//   width: 16px;
//   height: 16px;
// `;

// const CheckboxLabel = styled.label`
//   font-size: 14px;
//   color: #92400e;
//   font-weight: 600;
//   line-height: 1.4;
// `;

// const SubmitButton = styled.button`
//   background: linear-gradient(135deg, #f59e0b, #d97706);
//   color: #ffffff;
//   border: none;
//   padding: 12px 24px;
//   font-size: 15px;
//   font-weight: 700;
//   border-radius: 6px;
//   cursor: pointer;
//   width: 100%;
//   margin-top: 15px;
//   transition: opacity 0.2s;

//   &:hover {
//     opacity: 0.95;
//   }
// `;

// const FaqContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   margin: 15px 0;
// `;

// const FaqItem = styled.div`
//   background: #ffffff;
//   border: 1px solid #e5e7eb;
//   border-radius: 8px;
//   overflow: hidden;
//   box-shadow: 0 1px 4px rgba(0, 0, 0, 0.01);
// `;

// const FaqQuestion = styled.button`
//   width: 100%;
//   padding: 14px 18px;
//   background: none;
//   border: none;
//   text-align: left;
//   font-size: 16px;
//   font-weight: 700;
//   color: #1f2937;
//   cursor: pointer;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;

//   &:hover {
//     color: #d97706;
//   }
// `;

// const FaqAnswer = styled.div`
//   padding: 0 18px 14px 18px;
//   font-size: 14px;
//   color: #4b5563;
//   line-height: 1.5;
//   border-top: 1px solid #f3f4f6;
//   background: #fdfbf7;
// `;

// export default function ApplicationAndFaqPage() {
//   const [openFaq, setOpenFaq] = useState(null);

//   const toggleFaq = (index) => {
//     setOpenFaq(openFaq === index ? null : index);
//   };

//   const faqData = [
//     {
//       q: 'Why Coding and Robotics?',
//       a: 'Robotics is actually an application of Coding because robots are working with computer instructions. To control a robot, it is necessary to program it. Learning to code can allow your child to program or control a robot, computer, and even drones.'
//     },
//     {
//       q: 'What is the difference between the computer science class my child receives in school and this one?',
//       a: 'While school computer science tends to focus on theory and basic curriculum guidelines, our bootcamp emphasizes interactive, practical creation. Kids build live games, functional web pages, and program actual robotics systems from scratch.'
//     },
//     {
//       q: 'How will learning coding and robotics help my child’s education?',
//       a: 'It drastically improves problem-solving abilities, logical reasoning, persistence, and overall academic confidence in mathematics and science.'
//     },
//     {
//       q: 'Can I pay in installments?',
//       a: 'Yes, flexible payment plans can be arranged to accommodate parents. Reach out to our support team to discuss a convenient schedule.'
//     },
 
//     {
//       q: 'What will my kids come with for the bootcamp?',
//       a: 'Students are encouraged to come along with a personal laptop (if available) and an eagerness to learn and explore. We provide supplementary guidance and resources for every session.'
//     },
//     {
//       q: 'Why should I pay such an amount for my kids to learn coding?',
//       a: 'You are investing in high-value future-proof skills that position your child years ahead of peers, transforming screen time into productive asset-building under expert mentorship.'
//     },
   
//   ];

//   return (
//     <PageContainer>
//       <KidsCodePageHero />

//       {/* Motivation Header Section */}
//       <Fade triggerOnce>
//         <HeroSection>
//           <Badge>🚀 Shape Their Future Today</Badge>
//           <Title>Give Your Child the Ultimate Tech Advantage</Title>
//           <Subtitle>
//             Equip your child with critical problem-solving skills, artificial intelligence literacy, and hands-on coding proficiency designed for the innovators of tomorrow.
//           </Subtitle>
//         </HeroSection>
//       </Fade>

//       {/* Why Enroll Section */}
//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>Why Parents Choose Our Programs</SectionHeader>
//           <MotivationGrid>
//             <MotivationCard>
//               <CardTitle>🧠 Cognitive Growth & Logic</CardTitle>
//               <CardText>Coding trains young minds to break down complex challenges into manageable steps, boosting analytical reasoning across all school subjects.</CardText>
//             </MotivationCard>
//             <MotivationCard style={{ borderLeftColor: '#06b6d4' }}>
//               <CardTitle>🤖 Future-Ready AI & Tech</CardTitle>
//               <CardText>Move beyond passive video gaming. Teach your kids how artificial intelligence models, smart apps, and automated devices operate.</CardText>
//             </MotivationCard>
//             <MotivationCard style={{ borderLeftColor: '#10b981' }}>
//               <CardTitle>🏆 Proven Practical Outcomes</CardTitle>
//               <CardText>Every participant builds and showcases real functional projects, instilling deep confidence and a lifelong love for building.</CardText>
//             </MotivationCard>
//           </MotivationGrid>
//         </Section>
//       </Fade>

//       {/* Application Form Section */}
//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>Application Form</SectionHeader>
//           <FormWrapper>
//             <FormNotice>
//               Ensure that the information you have here is current as your child’s learning curve will be drawn from it.
//             </FormNotice>

//             <form onSubmit={(e) => e.preventDefault()}>
//               <FormGrid>
//                 <FormGroup>
//                   <Label>Parent's Name *</Label>
//                   <Input type="text" placeholder="Enter your first name here" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Parent's Address *</Label>
//                   <Input type="text" placeholder="Enter Parent Address here" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Date of Birth *</Label>
//                   <Input type="date" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Phone Number *</Label>
//                   <Input type="tel" placeholder="Example: +1 212-695-1962" required />
//                 </FormGroup>

//                 <FormGroup fullWidth>
//                   <Label>Email Address *</Label>
//                   <Input type="email" placeholder="Example: user@website.com" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Child's Name *</Label>
//                   <Input type="text" placeholder="Enter child's full name" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Child's School *</Label>
//                   <Input type="text" placeholder="Enter child's school name" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>City *</Label>
//                   <Input type="text" placeholder="Enter city" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Child's Age *</Label>
//                   <Input type="number" placeholder="Age in Numbers Only" required />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Gender *</Label>
//                   <Select required>
//                     <option value="">Select Gender</option>
//                     <option value="Male">Male</option>
//                     <option value="Female">Female</option>
//                   </Select>
//                 </FormGroup>

//                 <FormGroup>
//                   <Label>Have your kids attended any of our programs before? *</Label>
//                   <Select required>
//                     <option value="">Select option</option>
//                     <option value="YES">YES</option>
//                     <option value="NO">NO</option>
//                   </Select>
//                 </FormGroup>


//                 <FormGroup fullWidth>
//                   <Label>How Did You Find Out About Us? *</Label>
//                   <Select required>
//                     <option value="">Select referral source</option>
//                     <option value="Facebook">Facebook</option>
//                     <option value="Instagram">Instagram</option>
//                     <option value="Google">Google</option>
//                     <option value="Whatsapp">Whatsapp</option>
//                     <option value="Church">Church</option>
//                     <option value="Hand Bills">Hand Bills</option>
//                     <option value="The Blueskies Schools">The Blueskies Schools</option>
//                     <option value="Wellspring Preparatory School">Wellspring Preparatory School</option>
//                     <option value="Ridgeview Academy">Ridgeview Academy</option>
//                     <option value="Family and Friends">Family and Friends</option>
//                   </Select>
//                 </FormGroup>

//                 <CheckboxContainer>
//                   <Checkbox type="checkbox" id="payment-ack" required />
//                   <CheckboxLabel htmlFor="payment-ack">
//                     I understand that I will have to pay for the training*
//                   </CheckboxLabel>
//                 </CheckboxContainer>
//               </FormGrid>

//               <SubmitButton type="submit">Submit Application</SubmitButton>
//             </form>
//           </FormWrapper>
//         </Section>
//       </Fade>

//       {/* FAQ Section */}
//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>Frequently Asked Questions</SectionHeader>
//           <Subtitle style={{ textAlign: 'center', marginBottom: '15px' }}>
//             Got questions? We've got clear answers to help you get started.
//           </Subtitle>
//           <FaqContainer>
//             {faqData.map((item, index) => (
//               <FaqItem key={index}>
//                 <FaqQuestion onClick={() => toggleFaq(index)}>
//                   <span>{item.q}</span>
//                   <span>{openFaq === index ? '−' : '+'}</span>
//                 </FaqQuestion>
//                 {openFaq === index && <FaqAnswer>{item.a}</FaqAnswer>}
//               </FaqItem>
//             ))}
//           </FaqContainer>
//         </Section>
//       </Fade>
//     </PageContainer>
//   );
// }




import React, { useState } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import KidsCodePageHero from './KidsCodePageHero';
import Swal from 'sweetalert2';
import ClassRegistrationNotice from './ClassRegistrationNotice';
import KidsCodePaystackCardPayment from './KidsCodePaystackCardPayment';

const PageContainer = styled.div`
  background-color: #fcf8f5;
  color: #1a1a1a;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
  margin-top: 50px;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const Section = styled.section`
  padding: 10px;
  margin: 10px auto;
  max-width: 1200px;
`;

const HeroSection = styled(Section)`
  text-align: center;
  padding: 20px 10px;
  background: linear-gradient(135deg, #fef3c7, #fff7ed);
  border-radius: 12px;
  border: 1px solid #fde68a;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.05);
`;

const Badge = styled.span`
  background: #fef3c7;
  color: #d97706;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid #fde68a;
`;

const Title = styled.h1`
  font-size: 32px;
  color: #111827;
  margin: 10px 0;
  line-height: 1.2;
  font-weight: 900;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #4b5563;
  margin: 0 auto;
  max-width: 700px;
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const SectionHeader = styled.h2`
  font-size: 26px;
  background: linear-gradient(135deg, #f59e0b, #d97706, #b45309);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  margin: 16px 0 10px 0;
  font-weight: 800;
  letter-spacing: -0.5px;
  word-break: break-word;
`;

const MotivationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
  margin: 10px 0;
`;

const MotivationCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border-left: 4px solid #f59e0b;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  color: #1f2937;
  margin: 0;
  font-weight: 700;
  word-break: break-word;
`;

const CardText = styled.p`
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const FormWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  margin: 15px 0;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const FormNotice = styled.div`
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  padding: 12px;
  font-size: 14px;
  color: #92400e;
  border-radius: 0 6px 6px 0;
  margin-bottom: 15px;
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const FeedbackMessage = styled.div`
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 600;
  background: ${({ isError }) => (isError ? '#fee2e2' : '#d1fae5')};
  color: ${({ isError }) => (isError ? '#991b1b' : '#065f46')};
  border: 1px solid ${({ isError }) => (isError ? '#f87171' : '#34d399')};
  word-break: break-word;
  overflow-wrap: break-word;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: ${({ fullWidth }) => (fullWidth ? 'span 2' : 'span 1')};
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    grid-column: span 1;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  word-break: break-word;
`;

const Input = styled.input`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #1f2937;
  background: #f9fafb;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
  word-break: break-word;

  &:focus {
    border-color: #f59e0b;
    background: #ffffff;
  }
`;

const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #1f2937;
  background: #f9fafb;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus {
    border-color: #f59e0b;
    background: #ffffff;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
  grid-column: span 2;
  background: #fffbeb;
  border: 1px solid #fde68a;
  padding: 12px;
  border-radius: 6px;
  word-break: break-word;

  @media (max-width: 768px) {
    grid-column: span 1;
  }
`;

const Checkbox = styled.input`
  margin-top: 3px;
  accent-color: #f59e0b;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const CheckboxLabel = styled.label`
  font-size: 14px;
  color: #92400e;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
`;

const SubmitButton = styled.button`
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  margin-top: 15px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.95;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 15px 0;
`;

const FaqItem = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.01);
  word-break: break-word;
`;

const FaqQuestion = styled.button`
  width: 100%;
  padding: 14px 18px;
  background: none;
  border: none;
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;

  &:hover {
    color: #d97706;
  }
`;

const FaqAnswer = styled.div`
  padding: 0 18px 14px 18px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
  border-top: 1px solid #f3f4f6;
  background: #fdfbf7;
  word-break: break-word;
`;

export default function ApplicationAndFaqPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({ message: '', isError: false });

  const [formData, setFormData] = useState({
    parentName: '',
    course:'',
    parentAddress: '',
    dateOfBirth: '',
    phoneNumber: '',
    emailAddress: '',
    childName: '',
    childSchool: '',
    city: '',
    childAge: '',
    gender: '',
    previousProgram: '',
    referralSource: '',
    paymentAck: false,
  });

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitting(true);
//     setFeedback({ message: '', isError: false });

//     const data = new FormData();
//     Object.keys(formData).forEach((key) => {
//       data.append(key, formData[key]);
//     });

//     try {
//       const response = await fetch('https://elexdondigitalacademy.com/api/process_kids_code_application.php', {
//         method: 'POST',
//         body: data,
//       });
//       const result = await response.json();

//       if (result.success) {
//         setFeedback({ message: result.message + ` (Ref: ${result.reference})`, isError: false });
//         setFormData({
//           parentName: '',
//           parentAddress: '',
//           dateOfBirth: '',
//           phoneNumber: '',
//           emailAddress: '',
//           childName: '',
//           childSchool: '',
//           city: '',
//           childAge: '',
//           gender: '',
//           previousProgram: '',
//           referralSource: '',
//           paymentAck: false,
//         });
//       } else {
//         setFeedback({ message: result.error || 'An error occurred while submitting.', isError: true });
//       }
//     } catch (err) {
//       setFeedback({ message: 'Network or server error. Please try again.', isError: true });
//     } finally {
//       setSubmitting(false);
//     }
//   };



const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. SweetAlert2 Confirmation Dialog before submitting
    const confirmResult = await Swal.fire({
      title: 'Submit Application?',
      text: 'Are you sure you want to submit this registration application?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#f59e0b',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Submit',
      cancelButtonText: 'Cancel'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    setSubmitting(true);
    setFeedback({ message: '', isError: false });

    // 2. SweetAlert2 Loading State
    Swal.fire({
      title: 'Submitting Application...',
      text: 'Please wait while we process your request.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      const response = await fetch('https://elexdondigitalacademy.com/api/process_kids_code_application.php', {
        method: 'POST',
        body: data,
      });
      const result = await response.json();

      if (result.success) {
        const successMsg = result.message + ` (Ref: ${result.reference})`;
        setFeedback({ message: successMsg, isError: false });
        
        // Reset Form Fields
        setFormData({
          parentName: '',
          course:"",
          parentAddress: '',
          dateOfBirth: '',
          phoneNumber: '',
          emailAddress: '',
          childName: '',
          childSchool: '',
          city: '',
          childAge: '',
          gender: '',
          previousProgram: '',
          referralSource: '',
          paymentAck: false,
        });

        // 3. SweetAlert2 Success Message
        Swal.fire({
          title: 'Success!',
          text: successMsg,
          icon: 'success',
          confirmButtonColor: '#f59e0b'
        });
      } else {
        const errorMsg = result.error || 'An error occurred while submitting.';
        setFeedback({ message: errorMsg, isError: true });

        // 4. SweetAlert2 Failure Message (Server Error)
        Swal.fire({
          title: 'Submission Failed',
          text: errorMsg,
          icon: 'error',
          confirmButtonColor: '#f59e0b'
        });
      }
    } catch (err) {
      const networkErrorMsg = 'Network or server error. Please try again.';
      setFeedback({ message: networkErrorMsg, isError: true });

      // 5. SweetAlert2 Failure Message (Network/Catch Error)
      Swal.fire({
        title: 'Connection Error',
        text: networkErrorMsg,
        icon: 'error',
        confirmButtonColor: '#f59e0b'
      });
    } finally {
      setSubmitting(false);
    }
  };


const faqData = [
    {
      q: 'Why Coding and Robotics?',
      a: 'Robotics is actually an application of Coding because robots are working with computer instructions. To control a robot, it is necessary to program it. Learning to code can allow your child to program or control a robot, computer, and even drones.'
    },
    {
      q: 'What is the difference between the computer science class my child receives in school and this one?',
      a: 'While school computer science tends to focus on theory and basic curriculum guidelines, our bootcamp emphasizes interactive, practical creation. Kids build live games, functional web pages, and program actual robotics systems from scratch.'
    },
    {
      q: 'How will learning coding and robotics help my child’s education?',
      a: 'It drastically improves problem-solving abilities, logical reasoning, persistence, and overall academic confidence in mathematics and science.'
    },
    {
      q: 'Can I pay in installments?',
      a: 'Yes, flexible payment plans can be arranged to accommodate parents. Reach out to our support team to discuss a convenient schedule.'
    },
    {
      q: 'What will my kids come with for the bootcamp?',
      a: 'Students are encouraged to come along with a personal laptop (if available) and an eagerness to learn and explore. We provide supplementary guidance and resources for every session.'
    },
    {
      q: 'Why should I pay such an amount for my kids to learn coding?',
      a: 'You are investing in high-value future-proof skills that position your child years ahead of peers, transforming screen time into productive asset-building under expert mentorship.'
    },
  ];

  return (
    <PageContainer>
      <KidsCodePageHero />

      {/* Motivation Header Section */}
      <Fade triggerOnce>
        <HeroSection>
          <Badge>🚀 Shape Their Future Today</Badge>
          <Title>Give Your Child the Ultimate Tech Advantage</Title>
          <Subtitle>
            Equip your child with critical problem-solving skills, artificial intelligence literacy, and hands-on coding proficiency designed for the innovators of tomorrow.
          </Subtitle>
        </HeroSection>
      </Fade>

      {/* Why Enroll Section */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Why Parents Choose Our Programs</SectionHeader>
          <MotivationGrid>
            <MotivationCard>
              <CardTitle>🧠 Cognitive Growth & Logic</CardTitle>
              <CardText>Coding trains young minds to break down complex challenges into manageable steps, boosting analytical reasoning across all school subjects.</CardText>
            </MotivationCard>
            <MotivationCard style={{ borderLeftColor: '#06b6d4' }}>
              <CardTitle>🤖 Future-Ready AI & Tech</CardTitle>
              <CardText>Move beyond passive video gaming. Teach your kids how artificial intelligence models, smart apps, and automated devices operate.</CardText>
            </MotivationCard>
            <MotivationCard style={{ borderLeftColor: '#10b981' }}>
              <CardTitle>🏆 Proven Practical Outcomes</CardTitle>
              <CardText>Every participant builds and showcases real functional projects, instilling deep confidence and a lifelong love for building.</CardText>
            </MotivationCard>
          </MotivationGrid>
        </Section>
      </Fade>

      {/* Application Form Section */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader style={{fontSize:"3rem"}}>Application</SectionHeader>


          <ClassRegistrationNotice/>
          <KidsCodePaystackCardPayment/>

          <SectionHeader>Application Form</SectionHeader>
          <FormWrapper>
            <FormNotice>
              Ensure that the information you have here is current as your child’s learning curve will be drawn from it.
            </FormNotice>

            {feedback.message && (
              <FeedbackMessage isError={feedback.isError}>{feedback.message}</FeedbackMessage>
            )}

            <form onSubmit={handleSubmit}>
              <FormGrid>
                  <FormGroup fullWidth>
                  <Label>Select Course*</Label>
                  <Select
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Course</option>
                    <option value="Web Development">Web Development</option>
                    <option value="Mobile App building">Mobile App building</option>
                    <option value="Robotics and Hardware Engineering">Robotics and Hardware Engineering</option>
                    <option value="Artificial Intelligence">Artificial Intelligence</option>
                    <option value="Product Design UIUX">Product Design / UIUX</option>
                 
                  </Select>
                </FormGroup>



                <FormGroup>
                  <Label>Parent's Name *</Label>
                  <Input
                    type="text"
                    name="parentName"
                    value={formData.parentName}
                    onChange={handleChange}
                    placeholder="Enter your first name here"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Parent's Address *</Label>
                  <Input
                    type="text"
                    name="parentAddress"
                    value={formData.parentAddress}
                    onChange={handleChange}
                    placeholder="Enter Parent Address here"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Date of Birth *</Label>
                  <Input
                    type="date"
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Phone Number *</Label>
                  <Input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    placeholder="Example: +1 212-695-1962"
                    required
                  />
                </FormGroup>

                <FormGroup fullWidth>
                  <Label>Email Address *</Label>
                  <Input
                    type="email"
                    name="emailAddress"
                    value={formData.emailAddress}
                    onChange={handleChange}
                    placeholder="Example: user@website.com"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Child's Name *</Label>
                  <Input
                    type="text"
                    name="childName"
                    value={formData.childName}
                    onChange={handleChange}
                    placeholder="Enter child's full name"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Child's School *</Label>
                  <Input
                    type="text"
                    name="childSchool"
                    value={formData.childSchool}
                    onChange={handleChange}
                    placeholder="Enter child's school name"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>City *</Label>
                  <Input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="Enter city"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Child's Age *</Label>
                  <Input
                    type="number"
                    name="childAge"
                    value={formData.childAge}
                    onChange={handleChange}
                    placeholder="Age in Numbers Only"
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Gender *</Label>
                  <Select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </Select>
                </FormGroup>

                <FormGroup>
                  <Label>Have your kids attended any of our programs before? *</Label>
                  <Select
                    name="previousProgram"
                    value={formData.previousProgram}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select option</option>
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </Select>
                </FormGroup>

                <FormGroup fullWidth>
                  <Label>How Did You Find Out About Us? *</Label>
                  <Select
                    name="referralSource"
                    value={formData.referralSource}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select referral source</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Instagram">Instagram</option>
                    <option value="Google">Google</option>
                    <option value="Whatsapp">Whatsapp</option>
                    <option value="Church">Church</option>
                    <option value="Hand Bills">Hand Bills</option>
                    <option value="The Blueskies Schools">The Blueskies Schools</option>
                    <option value="Wellspring Preparatory School">Wellspring Preparatory School</option>
                    <option value="Ridgeview Academy">Ridgeview Academy</option>
                    <option value="Family and Friends">Family and Friends</option>
                  </Select>
                </FormGroup>

                <CheckboxContainer>
                  <Checkbox
                    type="checkbox"
                    id="payment-ack"
                    name="paymentAck"
                    checked={formData.paymentAck}
                    onChange={handleChange}
                    required
                  />
                  <CheckboxLabel htmlFor="payment-ack">
                    I understand that I will have to pay for the training*
                  </CheckboxLabel>
                </CheckboxContainer>
              </FormGrid>

              <SubmitButton type="submit" disabled={submitting}>
                {submitting ? 'Submitting Application...' : 'Submit Application'}
              </SubmitButton>
            </form>
          </FormWrapper>
        </Section>
      </Fade>

      {/* FAQ Section */}
      <Fade triggerOnce>
        <Section>
          <SectionHeader>Frequently Asked Questions</SectionHeader>
          <Subtitle style={{ textAlign: 'center', marginBottom: '15px' }}>
            Got questions? We've got clear answers to help you get started.
          </Subtitle>
          <FaqContainer>
            {faqData.map((item, index) => (
              <FaqItem key={index}>
                <FaqQuestion onClick={() => toggleFaq(index)}>
                  <span>{item.q}</span>
                  <span>{openFaq === index ? '−' : '+'}</span>
                </FaqQuestion>
                {openFaq === index && <FaqAnswer>{item.a}</FaqAnswer>}
              </FaqItem>
            ))}
          </FaqContainer>
        </Section>
      </Fade>
    </PageContainer>
  );
}